/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskScheduleCBase
 */
export interface ExecRiskScheduleCBase {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskScheduleCBase
     */
    ack_id?: string;
}

/**
 * Check if a given object implements the ExecRiskScheduleCBase interface.
 */
export function instanceOfExecRiskScheduleCBase(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskScheduleCBaseFromJSON(json: any): ExecRiskScheduleCBase {
    return ExecRiskScheduleCBaseFromJSONTyped(json, false);
}

export function ExecRiskScheduleCBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskScheduleCBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ack_id': !exists(json, 'ack_id') ? undefined : json['ack_id'],
    };
}

export function ExecRiskScheduleCBaseToJSON(value?: ExecRiskScheduleCBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ack_id': value.ack_id,
    };
}

